export const SERVER_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE_URL = SERVER_URL + "/api";

export const ENDPOINTS = {
  login: API_BASE_URL + "/auth/login",
  register: API_BASE_URL + "/auth/register",
  contact: API_BASE_URL + "/auth/contact",
  manageJournal: API_BASE_URL + "/user/get_journals",
  create_journal: API_BASE_URL + "/user/add_journal",
  deleteJournal: API_BASE_URL + "/user/delete_journal",
  updateJournal: API_BASE_URL + "/user/update_journal",
  getJournalByItsId: API_BASE_URL + "/user/get_journal_by_id",
  reviewerSearch: API_BASE_URL + "/web/reviewers_search",
  reviewerSearchAsPublisher: API_BASE_URL + "/user/reviewers_search",
  getPersonalDetails: API_BASE_URL + "/user/get_personal_details",
  getCountries: API_BASE_URL + "/web/get_countries",
  updateAuthorProfile: API_BASE_URL + "/user/update_personal_details",
  getStates: API_BASE_URL + "/web/get_states",
  getReviewerById: API_BASE_URL + "/web/get_reviewer_by_id",
  journalSearch: API_BASE_URL + "/web/journals_search",
  createPublication: API_BASE_URL + "/user/add_publication",
  getPublication: API_BASE_URL + "/user/get_publication",
  deletePublication: API_BASE_URL + "/user/delete_publication",
  submitResearchPaper: API_BASE_URL + "/user/submit_research",
  getPublicationById: API_BASE_URL + "/user/get_publication_by_id",
  updatePublication: API_BASE_URL + "/user/update_publication",
  reviewerRequests: API_BASE_URL + "/user/get_journals_join_requests",
  updateJournalStatus: API_BASE_URL + "/user/approve_reject_request",
  getPublishRequest: API_BASE_URL + "/user/get_publish_requests",
  joinJournal: API_BASE_URL + "/user/join_journal",
  researchPaperSearch: API_BASE_URL + "/user/research_paper_search",
  publisherJoinJournals: API_BASE_URL + "/user/publisher_join_journal",
  publisherJoinPaper: API_BASE_URL + "/user/publisher_join_paper",
  joinedAllJournals: API_BASE_URL + "/user/list_joined_journals",
  leaveJournals: API_BASE_URL + "/user/leave_journal",
  changePassword: API_BASE_URL + "/user/change_password",
  changePublishRequestStatus:
    API_BASE_URL + "/user/change_publish_request_status",
  getresearchPaper: API_BASE_URL + "/user/get_research_papers",
  deleteResearchPaper: API_BASE_URL + "/user/delete_research",
  updateResearchPaper: API_BASE_URL + "/user/update_research_paper",
  getResearchPaperById: API_BASE_URL + "/user/get_research_by_id",
  // joinedReviewers: API_BASE_URL + "/user/get_joined_reviewers",
  assignRequestToReviewer: API_BASE_URL + "/user/assign_request_to_reviewer",
  getJournalDetailsById: API_BASE_URL + "/web/get_journal_by_id",
  getApprovedPublicationByUserId:
    API_BASE_URL + "/web/get_publication_by_User_id",
  journalPublishedPapers: API_BASE_URL + "/web/get_published_papers_by_journal",
  getPublicationByIdWeb: API_BASE_URL + "/web/get_publication_by_id",
  getAssignedRequest: API_BASE_URL + "/user/get_assigned_request",
  updateRemarks: API_BASE_URL + "/user/update_remarks",
  razorpay: API_BASE_URL + "/user/init_payment",
  getMyReviews: API_BASE_URL + "/user/get_my_reviews",
  forgetPassword: API_BASE_URL + "/web/forgot_password",
  resetPassword: API_BASE_URL + "/web/reset_password",
  updatePRDocument: API_BASE_URL + "/user/update_pr_document",
};

export const STATIC = {
  noImageURL: SERVER_URL + "/assets/no-user.jpg",
  frameImageURL: SERVER_URL + "/assets/frame2.png",
};
